import { Input } from 'antd';
import React, { forwardRef } from 'react';
// import PropTypes from 'prop-types';
import ReactInputMask from 'react-input-mask';

const index = forwardRef((props, ref) => {
  return (
    <ReactInputMask {...props}>
      {inputProps => (
        <Input
          ref={ref}
          allowClear
          disabled={props.disabled ? props.disabled : null}
          {...inputProps}
        />
      )}
    </ReactInputMask>
  );
});

index.propTypes = {};

export default index;
